import { isDefined, schAlertType } from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getDepreciatedCostPageRoute } from '../utils/getDepreciatedCostPageRoute.ts';

export const effectiveAgeLowerThanActualAge: AlertDefinition = ({
  improvementEntityIds,
  order,
  propertyDataEntities,
}) => {
  const faultyProperties = improvementEntityIds
    .map((id, index) => {
      const propertyData =
        id === 'subject'
          ? (propertyDataEntities[id] as SubjectPropertyDataState | undefined)?.subjectData
          : (propertyDataEntities[id] as CompPropertyDataState | undefined)?.compData;

      const { age: actualAge, effectiveAge } = propertyData?.editableData.improvements ?? {};

      return { id, index, actualAge, effectiveAge };
    })
    .filter(
      ({ actualAge, effectiveAge }) =>
        isDefined(actualAge) && isDefined(effectiveAge) && effectiveAge > actualAge,
    );

  if (faultyProperties.length === 0) return [];

  return faultyProperties.map(({ id: propertyID, index, actualAge, effectiveAge }) => {
    let propertyName = '';
    if (propertyID === 'subject') {
      propertyName = 'Subject';
    } else if (propertyID === 'subjectArv') {
      propertyName = 'Subject ARV';
    } else {
      propertyName = `Comparable ${index}`;
    }

    return {
      type: schAlertType.enum.effectiveAgeLowerThanActualAge,
      status: 'active' as const,
      severity: 'error' as const,
      orderType: ['saas', 'appraisify'] as const,
      message: `Effective Age of ${propertyName} (${effectiveAge} years) must be less than or equal to its Actual Age (${actualAge} years).`,
      propertyID,
      fixingInfo: {
        tips: 'Tips: Effective Age cannot exceed the actual chronological age. Provide clear justification if you believe the current entry is appropriate due to unique physical depreciation or other condition-related factors.',
        pairedCostRouteItem: getDepreciatedCostPageRoute(order),
        fixingMethod: ['comment', 'action'] as const,
        commentAlwaysRequired: false,
      },
      triggers: [] as const,
    };
  });
};
